const mutations = {
  mutationBanks(state, payload) {
    state.banks = payload;
    state.bank = payload;
  },

  mutationCheckAccountNumber(state, payload) {
    state.isValidAccountNumber = payload;
  },
};

export default mutations;
